import { request, } from '@/utils';

export async function postContacts(payload: any) {
  return request.post(`/items/contacts`, payload);
}